module.exports = __webpack_public_path__ + "static/media/logoSuusjePluusje.ef1928be.png";